import { render } from "./CreateLotsMOQ.vue?vue&type=template&id=cfdb84fa"
import script from "./CreateLotsMOQ.vue?vue&type=script&lang=js"
export * from "./CreateLotsMOQ.vue?vue&type=script&lang=js"

import "./CreateLotsMOQ.vue?vue&type=style&index=0&id=cfdb84fa&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__